import ProgramApis from '@/app/program/apis'
import ProgramHome from '@/app/program/home'
import generateStaticProps from '@/utils/generate-static-props'

export default ProgramHome

export const getStaticPaths = async () => {
  const paths = await ProgramApis.getAll().then((programs) =>
    programs.map((program) => ({
      params: {
        handle: program.id,
      },
    })),
  )

  return {
    fallback: 'blocking',
    paths,
  }
}

export const getStaticProps = async ({ params: { handle } }) => {
  return generateStaticProps(() => ProgramApis.get(handle))
}
